'use strict';

angular.module('ecrd.core')
    .provider('CoreFormFields', function() {
        this.$get = ['CoreRecord', function CoreFormFields(CoreRecord) {
            return CoreRecord.getFormFields();
        }];
    });
